import { LoadableData } from '../../types/LoadableData';
import { UserInfo } from '../../utils/msal/UserInfo';

export interface AuthenticationState {
  userInfo: LoadableData<UserInfo | undefined>;
  tenantId?: string;
  token?: string;
  historyToken?: string;
}

export const AUTHENTICATION_INITIAL_STATE: AuthenticationState = {
  userInfo: { data: undefined, loading: true }
};
